import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterItem } from '../models/filter';
import { ICheckingStrategy } from '../models/strategy';
import { Utils } from '../../../services/utils.service';
import { Observable } from 'rxjs';

import { SHARED_MODULES } from '../../../../shared.';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

@Component({
    selector: 'app-tree-checkbox',
    templateUrl: './tree-checkbox.component.html',
    styleUrls: ['./tree-checkbox.component.scss'],
	imports: [SHARED_MODULES, FaIconComponent, PhIconComponent],
    standalone: true
})
export class TreeCheckboxComponent implements OnInit {

	@Input('element') element: FilterItem;
	@Input('checkingStrategy') checkingStrategy: ICheckingStrategy;
	@Input('loadChildren') loadChildren: (id?: number) => Observable<Array<FilterItem>>;
	@Output('check') check: EventEmitter<void> = new EventEmitter<void>();

	strategy: { checked: boolean, indeterminate: boolean };
	count: number = 100;

	constructor() {}

	ngOnInit() {
		this.strategy = this.checkingStrategy.getKey(this.element.id as number);
	}

	async onToggle(element: FilterItem) {
		if (element.opened) {
			element.opened = false;
			Utils.rec<FilterItem>(element.children, ((child: FilterItem) => child.opened = false));
			return;
		}

		if (element.hasOwnProperty('children') && Array.isArray(element.children) && element.children.length) {
			element.opened = true;
			return;
		}

		if (this.loadChildren) {
			element.loading = true;
			const checkingStrategy = this.checkingStrategy;
			this.loadChildren(element.id as number).subscribe({
				next(children: Array<FilterItem>) {
					children.forEach((item: FilterItem) =>
						checkingStrategy.setKey(
							item.id as number,
							checkingStrategy.getKey(item.id as number).checked || checkingStrategy.getKey(element.id as number).checked,
							checkingStrategy.getKey(item.id as number).indeterminate || checkingStrategy.getKey(element.id as number).indeterminate
						)
					);
					element.children = children
					element.loading = false;
					element.opened = true;
				},
				error() {
					element.children = [];
					element.loading = false;
				}
			});
		}
	}

	onChange(element: FilterItem): void {
		const strategy: { checked: boolean, indeterminate: boolean } = this.checkingStrategy.getKey(element.id as number);
		strategy.checked = !strategy.checked;
		strategy.indeterminate = false;
		Utils.rec<FilterItem>([element], (parent: FilterItem) => {
			if (parent.children && parent.children.length > 0) {
				const checked: boolean = this.checkingStrategy.getKey(parent.id as number).checked;
				parent.children.forEach((child: FilterItem) => {
					this.checkingStrategy.setKey(child.id as number, checked, false);
				});
			}
		});
		this.check.emit();
	}

	onCheck(): void {
		const strategy: { checked: boolean, indeterminate: boolean } = this.checkingStrategy.getKey(this.element.id as number);
		strategy.checked = this.element.children
			.every((child: FilterItem) => this.checkingStrategy.getKey(child.id as number).checked);
		strategy.indeterminate = !strategy.checked &&
			this.element.children.some((child: FilterItem) => this.checkingStrategy.any(child.id as number));
		this.check.emit();
	}

	showMore(): void {
		this.count += 100;
	}
}
